import { useEffect, useState } from "react";
import { X, ChevronLeft, ChevronRight, Play } from "lucide-react";

import g1 from "../assets/image/6x4 copy.jpg";
import g2 from "../assets/image/s1.jpeg";
import g3 from "../assets/image/s2.jpeg";
import g4 from "../assets/image/s3.jpeg";
import g5 from "../assets/image/s4.jpeg";
import g6 from "../assets/image/s5.jpeg";
import g7 from "../assets/image/s6.jpeg";
import g8 from "../assets/image/s7.jpeg";
import g9 from "../assets/image/s8.jpeg";
import g10 from "../assets/image/s9.jpeg";
import g11 from "../assets/image/s10.jpeg";
import g12 from "../assets/image/s11.jpeg";

import g13 from "../assets/image/s12.jpeg";
import g14 from "../assets/image/s13.jpeg";
import g15 from "../assets/image/s14.jpeg";
import g16 from "../assets/image/s15.jpeg";
import g17 from "../assets/image/s16.jpeg";

import g18 from "../assets/image/s17.jpeg";
import g19 from "../assets/image/s18.jpeg";
import g20 from "../assets/image/s19.jpeg";
import g21 from "../assets/image/s20.jpeg";
import g22 from "../assets/image/s21.jpeg";
import g23 from "../assets/image/s22.jpeg";
import g24 from "../assets/image/s23.jpeg";
import g25 from "../assets/image/s24.jpeg";
import g26 from "../assets/image/s25.jpeg";
import g27 from "../assets/image/s26.jpeg";
import g28 from "../assets/image/s27.jpeg";
import g29 from "../assets/image/s28.jpeg";

import g59 from "../assets/image/s29.jpeg";
import g30 from "../assets/image/s30.jpeg";
import g31 from "../assets/image/s31.jpeg";
import g32 from "../assets/image/s32.jpeg";
import g33 from "../assets/image/s33.jpeg";
import g34 from "../assets/image/s34.jpeg";
import g35 from "../assets/image/s35.jpeg";
import g36 from "../assets/image/s36.jpeg";
import g37 from "../assets/image/s37.jpeg";
import g38 from "../assets/image/s38.jpeg";
import g39 from "../assets/image/s39.jpeg";
import g40 from "../assets/image/s40.jpeg";
import g41 from "../assets/image/s41.jpeg";
import g42 from "../assets/image/s42.jpeg";
import g43 from "../assets/image/s43.jpeg";
import g44 from "../assets/image/s44.jpeg";
import g45 from "../assets/image/s45.jpeg";
import g46 from "../assets/image/s46.jpeg";
import g47 from "../assets/image/s47.jpeg";
import g48 from "../assets/image/s48.jpeg";
import g49 from "../assets/image/s49.jpeg";
import g50 from "../assets/image/s50.jpeg";
import g51 from "../assets/image/s51.jpeg";
import g52 from "../assets/image/s52.jpeg";
import g53 from "../assets/image/s53.jpeg";
import g54 from "../assets/image/s54.jpeg";
import g55 from "../assets/image/s55.jpeg";
import g56 from "../assets/image/s56.jpeg";
import g57 from "../assets/image/s57.jpeg";
import g58 from "../assets/image/s58.jpeg";

import g60 from "../assets/image/s59.jpeg";
import g61 from "../assets/image/s60.jpeg";
import g62 from "../assets/image/s61.jpeg";
import g63 from "../assets/image/s62.jpeg";
import g64 from "../assets/image/s63.jpeg";
import g65 from "../assets/image/s64.jpeg";
import g66 from "../assets/image/s65.jpeg";
import g67 from "../assets/image/s66.jpeg";
import g68 from "../assets/image/s67.jpeg";
import g69 from "../assets/image/s68.jpeg";
import g70 from "../assets/image/s69.jpeg";
import g71 from "../assets/image/s70.jpeg";
import g72 from "../assets/image/s71.jpeg";
import g73 from "../assets/image/s72.jpeg";
import g74 from "../assets/image/s73.jpeg";
import g75 from "../assets/image/s74.jpeg";
import g76 from "../assets/image/s75.jpeg";
import g77 from "../assets/image/s76.jpeg";
import g78 from "../assets/image/s77.jpeg";

import g79 from "../assets/image/s78.jpeg";
import g80 from "../assets/image/s79.jpeg";
import g81 from "../assets/image/s80.jpeg";
import g82 from "../assets/image/s81.jpeg";
import g83 from "../assets/image/s82.jpeg";

import g84 from "../assets/image/s83.jpeg";
import g85 from "../assets/image/s84.jpeg";
import g86 from "../assets/image/s85.jpeg";
import g87 from "../assets/image/s86.jpeg";
import g88 from "../assets/image/s87.jpeg";

import g89 from "../assets/image/s88.jpeg";
import g90 from "../assets/image/s89.jpeg";

import g91 from "../assets/image/s90.jpeg";
import g92 from "../assets/image/s91.jpeg";
import g93 from "../assets/image/s92.jpeg";
import g94 from "../assets/image/s93.jpeg";
import g95 from "../assets/image/s94.jpeg";
import g96 from "../assets/image/s95.jpeg";
import g97 from "../assets/image/s96.jpeg";

import g98 from "../assets/image/s97.jpeg";
import g99 from "../assets/image/s98.jpeg";
import g100 from "../assets/image/s99.jpeg";
import g101 from "../assets/image/s100.jpeg";
import g102 from "../assets/image/s101.jpeg";
import g103 from "../assets/image/s102.jpeg";
import g104 from "../assets/image/s103.jpeg";
import g105 from "../assets/image/s104.jpeg";
import g106 from "../assets/image/s105.jpeg";
import g107 from "../assets/image/s106.jpeg";
import g108 from "../assets/image/s107.jpeg";
import g109 from "../assets/image/s108.jpeg";
import g110 from "../assets/image/s109.jpeg";
import g111 from "../assets/image/s110.jpeg";
import g112 from "../assets/image/s111.jpeg";
import g113 from "../assets/image/s112.jpeg";
import g114 from "../assets/image/s113.jpeg";
import g115 from "../assets/image/s114.jpeg";
import g116 from "../assets/image/s115.jpeg";
import g117 from "../assets/image/s116.jpeg";
import g118 from "../assets/image/s117.jpeg";
import g119 from "../assets/image/s118.jpeg";
import g120 from "../assets/image/s119.jpeg";
import g121 from "../assets/image/s120.jpeg";
import g122 from "../assets/image/s121.jpeg";
import g123 from "../assets/image/s122.jpeg";
import g124 from "../assets/image/s123.jpeg";

import g125 from "../assets/image/s124.jpeg";
import g126 from "../assets/image/s125.jpeg";
import g127 from "../assets/image/s126.jpeg";
import g128 from "../assets/image/s127.jpeg";

import g129 from "../assets/image/s128.jpeg";
import g130 from "../assets/image/s129.jpeg";
import g131 from "../assets/image/s130.jpeg";
import g132 from "../assets/image/s131.jpeg";
import g133 from "../assets/image/s132.jpeg";
import g134 from "../assets/image/s133.jpeg";
import g135 from "../assets/image/s134.jpeg";
import g136 from "../assets/image/s135.jpeg";
import g137 from "../assets/image/s136.jpeg";
import g138 from "../assets/image/s137.jpeg";
import g139 from "../assets/image/s138.jpeg";
import g140 from "../assets/image/s139.jpeg";

import g141 from "../assets/image/s140.jpeg";
import g142 from "../assets/image/s141.jpeg";
import g143 from "../assets/image/s142.jpeg";
import g144 from "../assets/image/s143.jpeg";
import g145 from "../assets/image/s144.jpeg";
import g146 from "../assets/image/s145.jpeg";
import g147 from "../assets/image/s146.jpeg";
import g148 from "../assets/image/s147.jpeg";
import g149 from "../assets/image/s148.jpeg";
import g150 from "../assets/image/s149.jpeg";
import g151 from "../assets/image/s150.jpeg";
import g152 from "../assets/image/s151.jpeg";
import g153 from "../assets/image/s152.jpeg";
import g154 from "../assets/image/s153.jpeg";
import g155 from "../assets/image/s154.jpeg";
import g156 from "../assets/image/s155.jpeg";
import g157 from "../assets/image/s156.jpeg";
import g158 from "../assets/image/s157.jpeg";
import g159 from "../assets/image/s158.jpeg";
import g160 from "../assets/image/s159.jpeg";
import g161 from "../assets/image/s160.jpeg";
import g162 from "../assets/image/s161.jpeg";
import g163 from "../assets/image/s162.jpeg";
import g164 from "../assets/image/s163.jpeg";
import g165 from "../assets/image/s164.jpeg";
import g166 from "../assets/image/s165.jpeg";

// import g63 from "../assets/image/s63.jpeg";
// import g61 from "../assets/image/s61.jpeg";
// import g62 from "../assets/image/s62.jpeg";
// import g63 from "../assets/image/s63.jpeg";

import v1 from "../assets/video/video1.mp4";
import v2 from "../assets/video/video2.mp4";
import v3 from "../assets/video/video3.mp4";
import v4 from "../assets/video/video4.mp4";
import v5 from "../assets/video/video5.mp4";
import v6 from "../assets/video/video6.mp4";
import v7 from "../assets/video/video7.mp4";
import v8 from "../assets/video/video8.mp4";
import v9 from "../assets/video/video9.mp4";


function GalleryPreview() {

  /*
   * EVENT-WISE GALLERY
   *
   * Change the images inside each event whenever required.
   */

  const gallerySections = [

    {
      title: "CBSE Class 10 Result",
      subtitle: "Celebrating Excellence",
      media: [g1]
    },

    {
      title: "Opening Day of the School",
      subtitle: "Learning Never Stops",
      media: [v8, v9]
    },

    {
      title: "World Environment Day",
      subtitle: "Save Nature, Save Future",
      media: [g2, g3, g4 ,g5 ,g6]
    },

    {
      title: "Tribute to Our Beloved Founder",
      subtitle: "Mourning & Condolence",
      media: [g7, g8, g9, g10, g11, g12]
    },

    {
      title: "Parents' Orientation Program",
      subtitle: "Guiding Young Minds",
      media: [g13, g14, g15, g16, g17]
    },

    {
      title: "Aksharabhyasa",
      subtitle: "Beginning with Blessings",
      media: [g18, g19, g20, g21, g22, g23, g24, g25, g26, g27, g28, g29]
    },

    {
      title: "Field Trip ",
      subtitle: "Learning Beyond the Classroom",
      media: [g30,g31,g32,g33,g34,g35,g36,g37,g38,g39,
        g40,g41,g42,g43,g44,g45,g46,g47,g48,g49,
        g50,g51,g52,g53,g54,g55,g56,g57,g58,g59
      ]
    },

    {
      title: "Father's Day",
      subtitle: "Honouring Fathers",
      media: [g60, g61, g62, g63, g64, g65, g66, g67, g68, g69, g70,
        g71, g72, g73, g74, g75, g76, g77, g78, 
      ]
    },

    {
      title: "International Mud Day",
      subtitle: "Messy & Happy",
      media: [g79, g80, g81, g82, g83]
    },

    {
      title: "International Yoga Day",
      subtitle: "Healthy Body, Happy Mind",
      media: [g84, g85, g86, g87, g88, g89]
    },

    {
      title: "National Doctors' Day",
      subtitle: "Guardians of Health",
      media: [g90, v3]
    },

    {
      title: "World Sports Day",
      subtitle: "Stay Active, Stay Healthy",
      media: [g91, g92, g93, g94, g95, g96, g97]
    },

    {
      title: "Grandparents' Day",
      subtitle: "Love Beyond Generations – Celebrated on 18th July",
      media: [g98, g99, g100, g101, g102, g103, g104, g105, g106,
        g107, g108, g109, g110, g111, g112, g113, g114, g115, g116,
        g117, g118, g119, g120, g121, g122, g123, g124
      ]
    },

    {
      title: "Robotics Workshop",
      subtitle: "Build. Code. Create.",
      media: [g128, g125, g126, g127, v4]
    },

    {
      title: "Investiture Ceremony",
      subtitle: "Future Leaders",
      media: [g129, g130, g131, g132, g133, g134, g135, g136,
        g137, g138, g139, g140
      ]
    },

    {
      title: "Kargil Vijay Diwas",
      subtitle: "Salute to Our Heroes",
      media: [g141, g142, g143, g144, g145, g146, g147, g148,
        g149, g150, g151, g152, g153, g154, g155, g156, g157,
        g158, g159, g160, g161, g162, g163, g164, g165, g166, v5
      ]
    },

    {
      title: "June & July Achievers",
      subtitle: "Celebrating Student Success",
      media: [v6, v7]
    },

    // {
    //   title: "Independence Day Celebration",
    //   subtitle: "Celebrating the Spirit of Freedom",
    //   media: [g52, g53, g54, v1, v2]
    // },

    // /*
    //  * Remaining images
    //  * You can assign these to the correct event
    //  * after checking which photos belong to which event.
    //  */
    // {
    //   title: "More Campus Moments",
    //   subtitle: "Memories from Capitol Public School",
    //   media: [
    //     g55,
    //     g56,
    //     g57,
    //     g58,
    //     g59,
    //     g60,
    //     g61,
    //     g62,
    //     g63
    //   ]
    // }
  ];


  const [selectedItem, setSelectedItem] = useState(null);


  // Create one flat list for the popup viewer
  const allMedia = gallerySections.flatMap(section =>
    section.media.map(media => ({
      media,
      title: section.title,
      subtitle: section.subtitle
    }))
  );


  const selectedIndex =
    selectedItem !== null
      ? allMedia.findIndex(item => item.media === selectedItem.media)
      : -1;


  const nextItem = () => {

    if (selectedIndex === -1) return;

    const nextIndex =
      selectedIndex === allMedia.length - 1
        ? 0
        : selectedIndex + 1;

    setSelectedItem(allMedia[nextIndex]);
  };


  const prevItem = () => {

    if (selectedIndex === -1) return;

    const prevIndex =
      selectedIndex === 0
        ? allMedia.length - 1
        : selectedIndex - 1;

    setSelectedItem(allMedia[prevIndex]);
  };


  // Keyboard controls
  useEffect(() => {

    const handleKey = (e) => {

      if (!selectedItem) return;

      if (e.key === "Escape") {
        setSelectedItem(null);
      }

      if (e.key === "ArrowRight") {
        nextItem();
      }

      if (e.key === "ArrowLeft") {
        prevItem();
      }
    };

    window.addEventListener("keydown", handleKey);

    return () =>
      window.removeEventListener("keydown", handleKey);

  }, [selectedItem, selectedIndex]);


  // Prevent background scrolling
  useEffect(() => {

    document.body.style.overflow =
      selectedItem ? "hidden" : "auto";

    return () => {
      document.body.style.overflow = "auto";
    };

  }, [selectedItem]);


  return (

    <section className="py-24 bg-gradient-to-b from-white to-blue-50">

      <div className="max-w-7xl mx-auto px-6">

        {/* MAIN HEADING */}

        <div className="text-center mb-20">

          <h2 className="text-5xl font-bold text-blue-900 mb-4">
            School Gallery
          </h2>

          <div className="w-32 h-1 bg-yellow-500 mx-auto rounded-full mb-6"></div>

          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Celebrating achievements, memories, events and
            unforgettable moments from Capitol Public School.
          </p>

        </div>


        {/* EVENT SECTIONS */}

        <div className="space-y-24">

          {gallerySections.map((section, sectionIndex) => (

            <div
              key={sectionIndex}
              className="event-section"
            >

              {/* EVENT HEADING */}

              <div className="text-center mb-10">

                <h3 className="text-3xl md:text-4xl font-bold text-blue-900">
                  {section.title}
                </h3>

                <div className="w-20 h-1 bg-yellow-500 mx-auto my-4 rounded-full"></div>

                <p className="text-gray-600 text-lg">
                  {section.subtitle}
                </p>

              </div>


              {/* IMAGES / VIDEOS */}

              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-7">

                {section.media.map((media, index) => {

                  const isVideo =
                    typeof media === "string" &&
                    media.endsWith(".mp4");


                  const item = {
                    media,
                    title: section.title,
                    subtitle: section.subtitle
                  };


                  return (

                    <div
                      key={index}
                      onClick={() => setSelectedItem(item)}
                      className="group relative overflow-hidden rounded-[25px] bg-white shadow-xl hover:shadow-2xl cursor-pointer transition-all duration-500"
                    >

                      {/* IMAGE */}

                      {!isVideo && (

                        <img
                          src={media}
                          alt={section.title}
                          loading="lazy"
                          className="w-full h-[280px] object-cover group-hover:scale-110 transition duration-700"
                        />

                      )}


                      {/* VIDEO */}

                      {isVideo && (

                        <div className="relative">

                          <video
                            src={media}
                            muted
                            className="w-full h-[280px] object-cover"
                          />

                          {/* VIDEO PLAY BUTTON */}

                          <div className="absolute inset-0 flex items-center justify-center">

                            <div className="bg-white/90 backdrop-blur-md p-5 rounded-full shadow-xl group-hover:scale-110 transition">

                              <Play
                                size={32}
                                className="text-blue-900"
                                fill="currentColor"
                              />

                            </div>

                          </div>

                        </div>

                      )}


                      {/* HOVER OVERLAY */}

                      <div className="absolute inset-0 bg-gradient-to-t from-blue-950/90 via-blue-900/20 to-transparent opacity-0 group-hover:opacity-100 transition duration-500"></div>


                      {/* HOVER TEXT */}

                      <div className="absolute bottom-0 left-0 right-0 p-6 translate-y-8 group-hover:translate-y-0 opacity-0 group-hover:opacity-100 transition duration-500">

                        <h4 className="text-white text-xl font-bold">
                          {section.title}
                        </h4>

                        <p className="text-yellow-300 text-sm mt-1">
                          {section.subtitle}
                        </p>

                      </div>

                    </div>

                  );

                })}

              </div>

            </div>

          ))}

        </div>

      </div>


      {/* FULL SCREEN MODAL */}

      {selectedItem && (

        <div className="fixed inset-0 z-50 bg-black/95 backdrop-blur-sm flex items-center justify-center p-5">


          {/* CLOSE */}

          <button
            onClick={() => setSelectedItem(null)}
            className="absolute top-6 right-6 bg-white/10 hover:bg-red-500 p-3 rounded-full text-white transition z-50"
          >
            <X size={28} />
          </button>


          {/* PREVIOUS */}

          <button
            onClick={prevItem}
            className="absolute left-5 md:left-10 bg-white/10 hover:bg-white/20 p-4 rounded-full text-white transition z-50"
          >
            <ChevronLeft size={35} />
          </button>


          {/* NEXT */}

          <button
            onClick={nextItem}
            className="absolute right-5 md:right-10 bg-white/10 hover:bg-white/20 p-4 rounded-full text-white transition z-50"
          >
            <ChevronRight size={35} />
          </button>


          {/* CONTENT */}

          <div className="max-w-6xl w-full flex flex-col items-center">

            {selectedItem.media.endsWith(".mp4") ? (

              <video
                src={selectedItem.media}
                controls
                autoPlay
                className="max-w-full max-h-[75vh] rounded-3xl shadow-2xl"
              />

            ) : (

              <img
                src={selectedItem.media}
                alt={selectedItem.title}
                className="max-w-full max-h-[75vh] rounded-3xl shadow-2xl object-contain"
              />

            )}


            {/* MODAL TITLE */}

            <div className="text-center mt-6">

              <h3 className="text-white text-2xl md:text-3xl font-bold">
                {selectedItem.title}
              </h3>

              <p className="text-yellow-400 mt-2 text-lg">
                {selectedItem.subtitle}
              </p>

            </div>

          </div>

        </div>

      )}

    </section>

  );
}


export default GalleryPreview;